module.exports = __webpack_public_path__ + "static/media/NYY_Logo.97d193b0.svg";